import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CreateAdvancedRuleMutationMutation,
  CreateAdvancedRuleMutationMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { ruleFragment } from "src/graphql/anti-fraud/fragments/RuleFragment";

export const createAdvancedRuleMutation = gql`
  mutation CreateAdvancedRuleMutation(
    $code: String!
    $name: String!
    $description: String!
    $query: String!
    $businessType: RuleBusinessType!
    $caseTypeCode: String!
  ) {
    advancedCreateRule(
      input: {
        code: $code
        name: $name
        description: $description
        query: $query
        businessType: $businessType
        caseTypeCode: $caseTypeCode
      }
    ) {
      ...RuleFragment
    }
  }

  ${ruleFragment}
` as TypedDocumentNode<
  CreateAdvancedRuleMutationMutation,
  CreateAdvancedRuleMutationMutationVariables
>;
